import { SlidersHorizontalIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import ExpandCollapseIcon from "common/components/ExpandCollapseIcon";
import { Button } from "common/components/ui/Button";

import FiltersSelection from "./FiltersSelection";

import type {
  NavigatorFilters,
  SelectedNavigatorFilters,
} from "../../../../types";

export default function DesktopFilters({
  accountId,
  isLoading,
  returnedFilters,
  selectedFilters,
  setSelectedFilters,
}: {
  accountId: string;
  isLoading: boolean;
  returnedFilters: NavigatorFilters;
  selectedFilters: SelectedNavigatorFilters;
  setSelectedFilters: (selectedFilters: SelectedNavigatorFilters) => void;
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div
      className={clsx(
        "flex flex-col rounded-4xl shrink-0 border border-black-200 transition-[width]",
        isExpanded ? "w-140" : "w-70",
      )}
    >
      <div className="flex items-center gap-x-2 border-b border-black-200 p-3">
        <div className="rounded-xl bg-black-100 p-2">
          <SlidersHorizontalIcon size={16} />
        </div>
        <span className="mr-auto text-sm-bold">Filters</span>
        {!!selectedFilters.length && (
          <Button
            variant="link-danger"
            size="sm"
            onClick={() => setSelectedFilters([])}
          >
            Clear all
          </Button>
        )}
        <Button
          variant="outline-black"
          intent="iconOnly"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <ExpandCollapseIcon isExpanded={isExpanded} />
        </Button>
      </div>

      <div className="flex gap-3 p-3">
        <FiltersSelection
          accountId={accountId}
          isSingleColumn={!isExpanded}
          isLoading={isLoading}
          returnedFilters={returnedFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </div>
    </div>
  );
}
